import React from 'react';
import { Card } from 'ui-toolkit';
import {
  DocumentHistoryTable,
  IDocumentHistoryTableProps,
} from '../../../components/order/documentsPortal/DocumentHistoryTable';
import {
  defaultNormalizedDocumentCategoriesData,
  useListDocumentCategoriesQuery,
} from '../../../API/documentCategories/DocumentCategoriesApi';

type IDocumentHistoryPageProps = IDocumentHistoryTableProps;

export const DocumentHistoryPage: React.FC<IDocumentHistoryPageProps> = (props) => {
  const documentType = props.documents[0] ? props.documents[0].category : undefined;
  const { data: { documentCategoriesByName } = defaultNormalizedDocumentCategoriesData } =
    useListDocumentCategoriesQuery();
  const categoryOption = documentType ? documentCategoriesByName[documentType] : undefined;
  return (
    <Card title={`Versions - ${categoryOption ? categoryOption.label : 'Standard Documents'}`}>
      <DocumentHistoryTable {...props} />
    </Card>
  );
};
